import CSSModules from 'react-css-modules';
import { Icon } from 'platfi-ui-components';
import { bemModifier } from 'utils/BEMHelper';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const ModalFixedHeader = ({ shadow }) => (
  <div styleName={classNames(...bemModifier('o-modal-sticky__header', { shadow }))}>
    <Icon className="a-svg-logo u-color-primary" icon="capitalise_logo" />
  </div>
);

ModalFixedHeader.propTypes = {
  shadow: PropTypes.bool,
};

export default CSSModules(ModalFixedHeader, styles, { allowMultiple: true });
